import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import ClientDashboard from "./pages/client-dashboard";
import AddNewClient from "./pages/add-new-client";
import ClientDetail from "./pages/client-detail";
import Login from "./pages/login";
import AdminPage from "./pages/admin";
import SearchResults from "./pages/search-results";
import { authApiService } from "./utils/authApiService";

const App = () => {
  const [auth, setAuth] = useState(null);
  const [loading, setLoading] = useState(true);

  // Initialize auth state on app load
  useEffect(() => {
    const token = authApiService.getStoredToken();
    if (token) {
      try {
        const payload = JSON.parse(atob(token.split(".")[1]));
        setAuth({ user: { id: payload.id, username: payload.username, role: payload.role }, token });
      } catch {
        authApiService.logout();
      }
    }
    setLoading(false);
  }, []);

  if (loading) {
    return <div className="min-h-screen flex items-center justify-center">Loading...</div>;
  }

  return (
    <Router>
      <Routes>
        {!auth && <Route path="*" element={<Login setAuth={setAuth} />} />}
        {auth && (
          <>
            <Route path="/login" element={<Navigate to="/client-dashboard" />} />
            <Route path="/client-dashboard" element={<ClientDashboard />} />
            <Route path="/add-new-client" element={<AddNewClient />} />
            <Route path="/client-detail/:clientId" element={<ClientDetail />} />
            <Route path="/search-results" element={<SearchResults />} />
            {auth.user.role === "admin" && <Route path="/admin" element={<AdminPage auth={auth} />} />}
            <Route path="*" element={<Navigate to="/client-dashboard" />} />
          </>
        )}
      </Routes>
    </Router>
  );
};

export default App;
